import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import NewItemFab from "../../../../components/new-item-fab";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NewLectureDialog from "../components/new-lecture-dialog";
import { useClassroomActions } from "../../../../hooks/useClassroomActions";
import LoadingSkeleton from "../../components/loading-skeleton";
import BackdropLoader from "../../../../components/backdrop-loader";
import LectureCard from "../components/lecture-preview-card";
import { AddCardOutlined, AddCircleOutlineOutlined } from "@mui/icons-material";
import { useSnackbar } from "../../../../components/snackbar";
import { useDomainActions } from "../../../../hooks/useDomainActions";

interface LecturesProp {
    hubActive: boolean | null;
}

export default function Lectures({ hubActive }: LecturesProp) {
    const { classroom_id } = useParams<{ classroom_id: string }>();

    const navigate = useNavigate();

    const { classrooms, getLectures, deleteLecture } = useClassroomActions();
    
    const classroom = classrooms?.[Number(classroom_id)];

    const lectures = classroom?.lectures;
    

    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const [runningTask, setRunningTask] = useState(-1);


    const [open, setOpen] = useState(false);

    const { showMessage } = useSnackbar();

    const preCreate = () => {
        if (!hubActive) {
            showMessage('Hub is not activated', 1);
            return;
        }

        if (runningTask !== -1) {
            showMessage('please wait...', 1);
            return;
        }

        setOpen(true);
    }
    

    const _deleteLecture = async (lecture_id: number) => {
        setDeleting(true);
        await deleteLecture(Number(classroom_id), lecture_id);
        setDeleting(false);
    };

    useEffect(() => {
        const loadLectures = async () => {
          await getLectures(Number(classroom_id))
        };
        setLoading(true);
        if (classroom && !lectures) loadLectures();
        setLoading(false);
    }, [classrooms]);
    

    if (hubActive === null || loading || !lectures) {
        return <LoadingSkeleton/>;
    }

    const lecturesList = Object.values(lectures);


    return (
        <Box>
            {lecturesList.length > 0 ? (
                <Grid container spacing={2}>
                    {lecturesList.sort((a, b) => new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime())
                    .map((lecture) => (
                        <Grid key={lecture.id} size={{ xs: 12, md: 6, lg: 4 }}>
                            <LectureCard
                                lecture={lecture}
                                onDelete={_deleteLecture}
                                runningTask={runningTask}
                            />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Box>
                    <Paper
                        elevation={0}
                        sx={{
                            minHeight: 200,
                            backgroundColor: "#f9fafb",
                            border: "1px dashed #d1d5db",
                            borderRadius: 2,
                            px: 4,
                            py: 6,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                        }}
                    >
                        <AddCircleOutlineOutlined sx={{ fontSize: 48, color: "#9ca3af", mb: 2 }} />

                        <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>
                            No Lectures Yet
                        </Typography>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 300 }}>
                            You haven’t created any lecture for this classroom yet.
                        </Typography>
                    </Paper>

                </Box>
            )}
           
            
            <NewItemFab onClick={preCreate} />

            <NewLectureDialog
                open={open}
                setOpen={setOpen}
                classroom_id={classroom_id!}
                setRunningTask={setRunningTask}
            />

            {deleting && <BackdropLoader/>}
        </Box>
    );
}